<template>
    <div class="v-flex">
        <div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <a
                        v-on  = "{ ...tooltip }"
                        @click.stop="onClick"
                    >
                        <v-icon
                            :color="active ? color : 'lightgray'"
                            :size="size"
                            class="toolbar-button"
                        >
                            {{ icon }}
                        </v-icon>
                    </a>
                </template>
                <span>{{ name }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>

export default {
    name: "CSiteIcon",
    components: {
    },

    props: {
        site: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        size: {
            required: false,
            type    : Number,
            default : function () {
                return 22;
            }
        },

        color: {
            required: false,
            type    : String,
            default : function () {
                return 'primary';
            }
        }
    },

    data: () => ({
        menu: false,
    }),

    computed: {
        icon () {
            if (!this.site || !this.site.type) {
                return null;
            }

            return this.site.type.symbol;
        },

        name () {
            if (!this.site || !this.site.type) {
                return null;
            }

            return this.site.type.name;
        },

        active () {
            if (!this.site.status) {
                return false;
            }

            return this.site.status.id === 1;
        }
    },

    methods: {
        onClick () {
            this.$emit("selected")
        },
    }
}
</script>

<style scoped>

</style>